import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { TranslateModule } from "@ngx-translate/core";


@Component({
    selector: "app-status-cell",
    template: `
    @if (cellValue) {
      <span class="text-success">
        {{ "PINNED.TRUE" | translate }}
      </span>
    }

    @if (!cellValue) {
      <span class="text-danger">
        {{ "PINNED.FALSE" | translate }}
      </span>
    }
    `,
    styles: [
        `
      :host {
        width: 100%;
        display: inline-flex;
        justify-content: flex-start;
      }
    `,
    ],
    standalone: true,
    imports: [TranslateModule],
})
export class StatusComponent implements ICellRendererAngularComp {
  params: boolean;
  public cellValue: boolean;

  agInit(params: ICellRendererParams): void {
    this.cellValue = this.getValueToDisplay(params);
  }

  getValueToDisplay(params: ICellRendererParams) {
    return params.value;
  }

  refresh() {
    return false;
  }
}
